<template>
  <el-container>
    <el-header class="container-header">
      <el-tabs
        class="container-tabs"
        :value="key"
        type="border-card"
        closable
        @tab-remove="handleRemove"
        @tab-click="handleClick"
      >
        <el-tab-pane :key="item.url" v-for="item in tabList" :name="item.url">
          <span slot="label">
            <i :class="item.icon"></i>
            {{item.title}}
          </span>
        </el-tab-pane>
        <el-container class="layout-wrap">
          <el-aside
            :width="sidebar.opened ? '70px' : '212px'"
            style="overflow: hidden;"
            class="side"
          >
            <el-tooltip class="item" effect="light" content="点击可刷新" placement="bottom">
              <div :class="{logo: true, 'is-close': sidebar.opened}" @click="onLoadFun">
                <img src="@/assets/img/logo.png" class="logo-img" />
                <div class="logo-text">
                  <p>Risk Control</p>
                </div>
              </div>
            </el-tooltip>
            <Menu ref="menu" />
          </el-aside>
          <el-container>
            <el-header class="header">
              <el-row type="flex" justify="space-between" align="center" style="height:62px">
                <div class="left-box">
                  <i
                    :class="{'icon iconfont iconhuagshouqi': !sidebar.opened, 'icon iconfont iconhuagzhankai': sidebar.opened}"
                    @click="toggleFole"
                  ></i>
                  &nbsp;
                  <Breadcrumb style="margin-left:20px" />
                </div>
                <div class="right-box">
                  <div class="current-time">{{ time }}</div>
                  <!-- <LangSelect style="line-height:60px;width:40px;text-align:center"/> -->
                  <User />
                </div>
              </el-row>
            </el-header>
            <el-main class="content">
              <transition name="fade-transform" mode="out-in">
                <keep-alive :exclude="noCache">
                  <router-view :key="key" />
                </keep-alive>
              </transition>
            </el-main>
          </el-container>
        </el-container>
      </el-tabs>
    </el-header>
  </el-container>
</template>

<script>
import LangSelect from "@/components/LangSelect";
import Menu from "./components/menu";
import User from "./components/user";
import Breadcrumb from "@/components/Breadcrumb";
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  components: {
    // LangSelect,
    Breadcrumb,
    Menu,
    User
  },
  data() {
    return {
      time: "",
      tabList: [],
      tabIndex: 0,
      noCache: []
    };
  },
  watch: {
    "$store.getters.historyList": {
      immediate: true,
      handler(val) {
        this.tabList = [];
        val.map(item => {
          if (item.name && item.name != "Home") {
            this.tabList.push(item);
          }
        });
        if (
          this.noCache.length > 0 &&
          this.noCache.includes(this.$route.name)
        ) {
          const index = this.noCache.indexOf(this.$route.name);
          this.noCache.splice(index, 1);
        }
      }
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    key() {
      return this.$route.fullPath;
    }
  },
  methods: {
    onLoadFun() {
      location.reload();
    },
    handleClick(tab, event) {
      this.$router.push(tab.name);
    },
    handleRemove(targetName) {
      let delName = "";
      let delIndex = "";
      this.tabList.map((item, i) => {
        if (item.url == targetName) {
          delName = item.name;
          delIndex = i;
        }
      });
      if (this.tabList.length > 1) {
        // 关闭
        let index;
        const len = this.tabList.length;
        if (delIndex > 0) {
          if (len >= 3 && delIndex === len - 2) {
            // 从中间删除
            index = len - 1;
          } else {
            // 从最后删除
            index = len - 2;
          }
        } else {
          // 只有两个时删除
          index = 1;
        }
        this.$router.push(this.tabList[index].url);
      }
      setTimeout(() => {
        this.noCache.push(delName);
      }, 300);
      this.$store.dispatch("app/delItem", targetName);
    },
    toggleFole() {
      this.$store.dispatch("app/toggleSideBar");
    },
    getCurrentTime() {
      const offset = this.$moment().utcOffset() / 60; // 获取获取UTC偏移量(时差)
      const offsetStr =
        offset >= 0 ? `(UTC+${offset}:00)` : `(UTC-${offset}:00)`;
      setInterval(() => {
        const currentUtcTime = this.$moment
          .utc()
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
        this.time = currentUtcTime + offsetStr;
      }, 1000);
    }
  },
  mounted() {
    this.getCurrentTime();
  }
};
</script>
<style lang="scss" scoped>
.iconfont {
  vertical-align: sub;
  font-size: 20px;
  font-weight: normal !important;
}
/deep/ {
  .el-menu {
    border: none;
  }
  .el-menu--collapse {
    width: 70px;
  }
  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      a {
        color: #333 !important;
      }
      .no-redirect {
        color: rgba(0, 0, 0, 0.5) !important;
      }
    }
  }
}
.logo {
  cursor: pointer;
}
</style>
